import * as React from 'react';
import { createComponent, ErrorType, errorRing, styled, } from '@workday/canvas-kit-react/common';
import { borderRadius, inputColors, spaceNumbers, type } from '@workday/canvas-kit-react/tokens';
export var TextAreaResizeDirection;
(function (TextAreaResizeDirection) {
    TextAreaResizeDirection["None"] = "none";
    TextAreaResizeDirection["Both"] = "both";
    TextAreaResizeDirection["Horizontal"] = "horizontal";
    TextAreaResizeDirection["Vertical"] = "vertical";
})(TextAreaResizeDirection || (TextAreaResizeDirection = {}));
const StyledTextArea = styled('textarea')(({ theme, error }) => ({
    ...type.levels.subtext.large,
    border: `1px solid ${inputColors.border}`,
    display: 'block',
    backgroundColor: inputColors.background,
    borderRadius: borderRadius.m,
    boxSizing: 'border-box',
    minHeight: 64,
    minWidth: 280,
    transition: '0.2s box-shadow, 0.2s border-color',
    padding: spaceNumbers.xxs,
    margin: 0,
    '&::webkit-resizer': {
        display: 'none',
    },
    '&::placeholder': {
        color: inputColors.placeholder,
    },
    '&:hover': {
        borderColor: inputColors.hoverBorder,
    },
    '&:focus:not([disabled])': {
        borderColor: theme.canvas.palette.common.focusOutline,
        boxShadow: `inset 0 0 0 1px ${theme.canvas.palette.common.focusOutline}`,
        outline: 'none',
    },
    '&:disabled': {
        backgroundColor: inputColors.disabled.background,
        borderColor: inputColors.disabled.border,
        color: inputColors.disabled.text,
        '&::placeholder': {
            color: inputColors.disabled.text,
        },
    },
    ...errorRing(error, theme),
}), ({ resize, grow }) => ({
    width: grow ? '100%' : undefined,
    resize: grow ? TextAreaResizeDirection.Vertical : resize,
}));
export const TextArea = createComponent('textarea')({
    displayName: 'TextArea',
    Component: ({ resize = TextAreaResizeDirection.Both, grow, ...elemProps }, ref, Element) => React.createElement(StyledTextArea, Object.assign({ ref: ref, as: Element, grow: grow, resize: resize }, elemProps)),
    subComponents: {
        ErrorType,
        ResizeDirection: TextAreaResizeDirection,
    },
});
